import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, icons, notificationsColors, services, sizes } from '@/utils'

import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import dialog from '@/components/services/notifications/dialog'
import sticker from '@/components/sticker'
import date from '@/components/templates/service/item/date'

function renderChannel(h) {
  if (this.value.channel) {
    return h(
      squircle,
      {
        props: {
          size: sizes.small,
          color: notificationsColors[this.value.channel],
          iconSVG: this.value.channel,
          iconTooltip: this.getTranslate(`${services.sendings}.types.${this.value.channel}`)
        }
      }
    )
  }

  return h('div')
}
function renderType(h) {
  if (this.value.type) {
    let color = Colors.grey
    let icon = icons.check
    if (this.value.isRead) {
      color = Colors.success
      icon = icons.done_all
    }

    return h(
      sticker,
      {
        props: {
          value: this.getTranslate(`${services.notifications}.events.${this.value.type}`),
          label: this.getTranslate(`${services.notifications}.labels.type`),
          color,
          icon,
          iconTooltip: this.iconIsReadTooltip
        }
      }
    )
  }
}
function renderInfo(h) {
  return h(
    'div',
    {
      class: `${services.notifications}-template-panel__info`
    },
    [
      renderChannel.call(this, h),
      renderType.call(this, h)
    ]
  )
}
function renderText(h) {
  if (this.viewport.size.width > 600) {
    if (this.value.text) {
      return h(
        sticker,
        {
          props: {
            value: this.value.text,
            label: this.getTranslate(`${services.notifications}.labels.text`)
          }
        }
      )
    }

    return h('div')
  }
}
function renderTargetUser(h) {
  if (this.value.targetUser || this.value.targetUserId) {
    if (this.viewport.size.width > 768) {
      return h(
        sticker,
        {
          props: {
            value: this.value.targetUser || this.value.targetUserId,
            label: this.getTranslate(`${services.notifications}.labels.owner`),
            pathToTitle: 'username',
            maxWidth: 200,
            width: '100%'
          }
        }
      )
    }
  }
}
function renderSourceButton(h) {
  return h(
    button,
    {
      class: { 'hover-child': this.viewport.size.width > 768 },
      props: {
        icon: icons.code,
        mode: buttonModes.flat,
        color: Colors.primary
      },
      on: {
        click: () => {
          this.showDialog = true
        }
      }
    }
  )
}
function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}
function renderDialog(h) {
  return h(
    dialog,
    {
      props: {
        value: this.showDialog,
        data: this.value
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `service-template-item ${services.notifications}-template-panel hover-parent hover-parent--opacity`,
      style: { gridTemplateColumns: this.gridTemplateColumns }
    },
    [
      renderInfo.call(this, h),
      renderText.call(this, h),
      renderTargetUser.call(this, h),
      renderSourceButton.call(this, h),
      renderCreatedAt.call(this, h),
      renderDialog.call(this, h)
    ]
  )
}
